import koleso1 from "./img/koleso1.png";
import koleso2 from "./img/koleso2.png";
import koleso3 from "./img/koleso3.png";
import face1 from "./img/face1.png";
import face2 from "./img/face2.png";
import face3 from "./img/face3.png";
import ai1 from "./img/ai1.png";
import ai2 from "./img/ai2.png";
import ai3 from "./img/ai3.png";
import cat1 from "./img/cat1.png";
import cat2 from "./img/cat2.png";
import cat3 from "./img/cat3.png";

import LegoItem from "./LegoItem";

import "./style.scss";

import { Accordion, AccordionTab } from "primereact/accordion";

const Lego = () => {
    return (
        <div className="lego">
            <div className="lego__title">
                Лего / <span className="lego__title_gray">Виджеты</span>
            </div>
            <Accordion multiple>
                {data.map((item, index) => (
                    <AccordionTab key={index} header={item.title}>
                        <LegoItem images={item.images} keyToGet={item.title.toLowerCase()} />
                    </AccordionTab>
                ))}
            </Accordion>
        </div>
    );
};

export default Lego;

const data = [
    { title: "Koleso", images: [koleso1, koleso2, koleso3] },
    { title: "Face", images: [face1, face2, face3] },
    { title: "AI", images: [ai1, ai2, ai3] },
    { title: "Categoria", images: [cat1, cat2, cat3] },
];
